/**
 * @param editor pointer to main editor object used to initialize
 *        each command object with a reference to the editor
 * @constructor
 */

import { Editor } from "./editor.js";

class Command {
	undo() {
		throw new Error('Method not implemented.');
	}
	execute() {
		throw new Error('Method not implemented.');
	}
	id = - 1;
	inMemory = false;
	updatable = false;
	type = '';
	name = '';
	editor:Editor;
	constructor( editor:Editor ) {
		this.editor = editor;
	}

	update(cmd:Command){
		throw new Error('Method not implemented.');
	}

}

export { Command };
